/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Step_RunInputs */

const cs_ebr_step_run = /** @type {(inputs: Ebr_Step_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import`)
};

const en_ebr_step_run = /** @type {(inputs: Ebr_Step_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Run`)
};

/**
* | output |
* | --- |
* | "Run" |
*
* @param {Ebr_Step_RunInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_step_run = /** @type {((inputs?: Ebr_Step_RunInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Step_RunInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_step_run(inputs)
	return cs_ebr_step_run(inputs)
});